<template>
  <li class="flex flex-col gap-3 rounded-md border p-3">
    <div class="flex items-start gap-3">
      <span class="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-700 dark:text-emerald-300">
        <Check class="h-3.5 w-3.5" />
      </span>
      <div class="flex flex-col gap-1">
        <p class="text-sm font-medium">
          {{ checklistTemplateItemInstructionLabel }}
        </p>
        <p v-if="itemTemplate.details" class="whitespace-pre-wrap text-xs text-muted-foreground">
          {{ itemTemplate.details }}
        </p>
      </div>
    </div>
  </li>
</template>

<script setup>
import { computed } from 'vue'
import { Check } from 'lucide-vue-next'

const props = defineProps({
  itemTemplate: {
    type: Object,
    required: true,
  },
})

const checklistTemplateItemInstructionLabel = computed(() => {
  return props.itemTemplate.instruction || `Checklist template item #${props.itemTemplate.id}`
})
</script>
